// extracted by mini-css-extract-plugin
export default {"container":"input-ui_container__BPhje","input":"input-ui_input__kWoLh","customLabel":"input-ui_customLabel__Pc3Sx","customLabel_error":"input-ui_customLabel_error__-gXUA"};